<template>
  <div>
    <section class="">
        <div class="container">
            <figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
        </div>
    </section>
    <section>
			<div class="container">
				<ol class="breadcrumb hidden-xs">
						<li><a href="/">首頁</a></li>
						<li><a href="/product">購物商城</a></li>
						<li class="active">{{rowData.name}}</li>
				</ol>
				<div class="row">
					<div class="col-md-12 col-sm-12 col-xs-12 pull-right">
						<div class="row">
							<div class="col-sm-7 col-xs-12">
								<figure class="pic">
									<img :src="'https://files.i80.com.tw/images/product/'+rowData.imageL" class="img-responsive"/>
								</figure>
							</div>
							<div class="col-sm-5 col-xs-12">
								<h4 class="title">{{rowData.name}}</h4>
								<p>{{rowData.short}}</p>
								<ul class="list-unstyled product_intro">
									<li class="price_box">
										<span class="price">{{rowData.price}}</span>
									</li>
									<hr>
									<li><b class="title">付款方式</b>
										<ul class="list-unstyled list-inline payment">
											<li>信用卡</li>
											<li>ATM</li>
											<li>iBon</li>
										</ul>
									</li>
									<li>
										<b class="title">數量</b>
										<select  v-model="orderNumber" class="form-control amount">
												<option v-for="number in numbers" :value="number">{{ number }}</option>
										</select>
									</li>
								</ul>
								<button type="button" @click="addToCart(rowData)">
									<span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> 加入購物車
								</button>
                                <br/><br/>
                                <div class="fb-like"  :data-href="'https://www.i80.com.tw/product/'+rowData.id" data-share="true" data-width="120" data-show-faces="false"></div>
							</div>
						</div>
						<hr>
						<h4 class="title">產品介紹</h4>
						<p  class="editor" v-html="rowData.content"></p>
						<div class="fb-comments" data-href="this.id" data-num-posts="2" data-width="100%"></div>
					</div>

				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'GoodPrice',
  data () {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      rowData: {},
      orderNumber: 1,
      id: '',
      items: this.$store.getters.getCart,
      numbers: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10
      ]
    }
  },
  mounted: function () {
    // 尋找產品資料中是否有資料可取用
    let id = this.$route.params.id
    this.id = 'https://www.i80.com.tw/product/' + id
    let getProducts = this.$store.getters.getProducts
    let data = []
    getProducts.forEach(function (val, idx) {
      if (parseInt(val.id) === parseInt(id)) {
        data.push(val)
      }
    })
    // 若沒有在產品資料中則直接從伺服器取得
    if (data.length < 1) {
      this.$http.get(this.apiurl + 'api/getProductID/' + id).then(function (res) {
        this.rowData = res.body.data[0]
      }, function () {
        // console.log('loading products is failed.')
      })
    } else {
      this.rowData = data[0]
    }
  },
  methods: {
    ...mapActions([
      'SET_PRODUCTS'
    ]),
    addToCart (row) {
      let cart = this.items
      if (cart.length > 0) {
        if (cart[0].fid !== row.fid) {
          window.alert('平台採單店結帳，請先進行結帳再購買其他店家商品謝謝')
        }
      }
      this.$store.dispatch('ADD_TO_CART', row)
    }
  },
  computed: {
    ...mapGetters({
      popular: 'getPopular'
    })
  },
  watch: {
    orderNumber: {
      handler: function (val, oldVal) {
        this.rowData.quantity = val
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// GoodPrice.vue?5858131d